import api from '../../api/client';
// // src/pages/accountant/BankReconciliation.jsx
// import React, { useState, useEffect } from "react";
// import { HiUpload, HiDocumentDownload, HiRefresh } from "react-icons/hi";
// import config from "../../config";
// import { Button } from "react-bootstrap";

// export default function BankReconciliation() {
//   const [statements, setStatements] = useState([]);
//   const [selectedStatement, setSelectedStatement] = useState(null);
//   const [transactions, setTransactions] = useState([]);
//   const [uploadModalOpen, setUploadModalOpen] = useState(false);
//   const [matchingModalOpen, setMatchingModalOpen] = useState(false);
//   const [currentTransaction, setCurrentTransaction] = useState(null);
//   const [paymentOptions, setPaymentOptions] = useState([]);
//   const [transactionOptions, setTransactionOptions] = useState([]);
//   const environment =
//     window.location.hostname === "localhost" ? "development" : "production";
//   const apiUrl = config[environment].apiUrl;

//   useEffect(() => {
//     fetchStatements();
//   }, []);

//   const fetchStatements = () => {
//     fetch(`/reconciliation/statements`)
//       .then((res) => res.json())
//       .then(setStatements);
//   };

//   const fetchTransactions = (statementId) => {
//     fetch(`/reconciliation/transactions/${statementId}`)
//       .then((res) => res.json())
//       .then(setTransactions);
//   };

//   const handleStatementSelect = (statement) => {
//     setSelectedStatement(statement);
//     fetchTransactions(statement.id);
//   };

//   const handleAutoMatch = () => {
//     fetch(`/reconciliation/match/${selectedStatement.id}`, {
//       method: "POST",
//     }).then(() => {
//       fetchTransactions(selectedStatement.id);
//     });
//   };

//   const handleManualMatch = (transaction) => {
//     setCurrentTransaction(transaction);

//     // Fetch payment options
//     fetch(
//       `/payments?amount=${transaction.amount}&date=${transaction.transaction_date}`,
//     )
//       .then((res) => res.json())
//       .then((data) => setPaymentOptions(data));

//     // Fetch transaction options
//     fetch(
//       `/transactions?amount=${transaction.amount}&date=${transaction.transaction_date}`,
//     )
//       .then((res) => res.json())
//       .then((data) => setTransactionOptions(data));

//     setMatchingModalOpen(true);
//   };

//   const handleReconcile = () => {
//     fetch(`/reconciliation/reconcile/${selectedStatement.id}`, {
//       method: "POST",
//     })
//       .then((res) => res.json())
//       .then((data) => {
//         alert(
//           `Reconciliation completed! Discrepancy: Ksh ${data.discrepancy.toLocaleString()}`,
//         );
//         fetchStatements();
//       });
//   };

//   return (
//     <React.Fragment>
//       <div className="flex justify-between items-center mb-6">
//         <Button
//           onClick={() => setUploadModalOpen(true)}
//           className="flex items-center px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700"
//         >
//           <HiUpload className="mr-2" />
//           Upload Statement
//         </Button>
//       </div>

//       <div className="grid grid-cols-1 lg:grid-cols-4 gap-6">
//         {/* Statement List */}
//         <div className="lg:col-span-1 bg-white rounded-lg shadow">
//           <div className="p-4 border-b">
//             <h2 className="text-lg font-semibold">Bank Statements</h2>
//           </div>
//           <div className="overflow-y-auto max-h-[70vh]">
//             {statements.length === 0 ? (
//               <div className="p-4 text-center text-gray-500">
//                 No statements found
//               </div>
//             ) : (
//               statements.map((statement) => (
//                 <div
//                   key={statement.id}
//                   className={`p-4 border-b cursor-pointer hover:bg-gray-50 ${
//                     selectedStatement?.id === statement.id ? "bg-blue-50" : ""
//                   }`}
//                   onClick={() => handleStatementSelect(statement)}
//                 >
//                   <div className="font-medium">{statement.bank_account}</div>
//                   <div className="text-sm text-gray-500">
//                     {new Date(statement.statement_date).toLocaleDateString()}
//                   </div>
//                   <div className="flex justify-between mt-2">
//                     <span className="text-sm">
//                       {statement.reconciled_count}/{statement.transaction_count}{" "}
//                       reconciled
//                     </span>
//                     <span
//                       className={`text-xs px-2 py-1 rounded ${
//                         statement.processed
//                           ? "bg-green-100 text-green-800"
//                           : "bg-yellow-100 text-yellow-800"
//                       }`}
//                     >
//                       {statement.processed ? "Reconciled" : "Pending"}
//                     </span>
//                   </div>
//                 </div>
//               ))
//             )}
//           </div>
//         </div>

//         {/* Transactions Panel */}
//         {selectedStatement && (
//           <div className="lg:col-span-3 bg-white rounded-lg shadow">
//             <div className="p-4 border-b flex justify-between items-center">
//               <div>
//                 <h2 className="text-lg font-semibold">
//                   {selectedStatement.bank_account} -{" "}
//                   {new Date(
//                     selectedStatement.statement_date,
//                   ).toLocaleDateString()}
//                 </h2>
//                 <div className="text-sm text-gray-500">
//                   Opening: Ksh{" "}
//                   {selectedStatement.opening_balance.toLocaleString()} •
//                   Closing: Ksh{" "}
//                   {selectedStatement.closing_balance.toLocaleString()}
//                 </div>
//               </div>

//               <div className="flex space-x-2">
//                 <button
//                   onClick={handleAutoMatch}
//                   className="flex items-center px-3 py-1 bg-green-600 text-white rounded-md hover:bg-green-700"
//                 >
//                   <HiRefresh className="mr-1" />
//                   Auto Match
//                 </button>
//                 <button
//                   onClick={handleReconcile}
//                   disabled={selectedStatement.processed}
//                   className={`px-3 py-1 rounded-md ${
//                     selectedStatement.processed
//                       ? "bg-gray-400"
//                       : "bg-blue-600 hover:bg-blue-700"
//                   } text-white`}
//                 >
//                   Reconcile Statement
//                 </button>
//               </div>
//             </div>

//             <div className="overflow-x-auto max-h-[70vh]">
//               <table className="min-w-full">
//                 <thead className="bg-gray-50 sticky top-0">
//                   <tr>
//                     <th className="px-4 py-2 text-left">Date</th>
//                     <th className="px-4 py-2 text-left">Description</th>
//                     <th className="px-4 py-2 text-left">Reference</th>
//                     <th className="px-4 py-2 text-right">Amount</th>
//                     <th className="px-4 py-2 text-left">Status</th>
//                     <th className="px-4 py-2 text-left">Match</th>
//                   </tr>
//                 </thead>
//                 <tbody>
//                   {transactions.map((transaction) => (
//                     <tr
//                       key={transaction.id}
//                       className="border-t hover:bg-gray-50"
//                     >
//                       <td className="px-4 py-3 whitespace-nowrap">
//                         {new Date(
//                           transaction.transaction_date,
//                         ).toLocaleDateString()}
//                       </td>
//                       <td className="px-4 py-3">{transaction.description}</td>
//                       <td className="px-4 py-3">{transaction.reference}</td>
//                       <td
//                         className={`px-4 py-3 text-right font-medium ${
//                           transaction.amount > 0
//                             ? "text-green-600"
//                             : "text-red-600"
//                         }`}
//                       >
//                         {transaction.amount > 0 ? "+" : ""}
//                         {transaction.amount.toLocaleString()}
//                       </td>
//                       <td className="px-4 py-3">
//                         <span
//                           className={`px-2 py-1 text-xs rounded-full ${
//                             transaction.status === "reconciled"
//                               ? "bg-green-100 text-green-800"
//                               : transaction.status === "matched"
//                               ? "bg-blue-100 text-blue-800"
//                               : "bg-yellow-100 text-yellow-800"
//                           }`}
//                         >
//                           {transaction.status}
//                         </span>
//                       </td>
//                       <td className="px-4 py-3">
//                         {transaction.status !== "reconciled" && (
//                           <button
//                             onClick={() => handleManualMatch(transaction)}
//                             className="px-2 py-1 text-sm bg-gray-100 rounded hover:bg-gray-200"
//                           >
//                             Match
//                           </button>
//                         )}
//                         {transaction.payment_id && (
//                           <div className="text-xs text-gray-500">
//                             Payment #{transaction.payment_id}
//                           </div>
//                         )}
//                         {transaction.transaction_id && (
//                           <div className="text-xs text-gray-500">
//                             Transaction #{transaction.transaction_id}
//                           </div>
//                         )}
//                       </td>
//                     </tr>
//                   ))}
//                 </tbody>
//               </table>
//             </div>
//           </div>
//         )}
//       </div>

//       {/* Upload Modal */}
//       {uploadModalOpen && (
//         <UploadStatementModal
//           onClose={() => setUploadModalOpen(false)}
//           onUpload={fetchStatements}
//         />
//       )}

//       {/* Matching Modal */}
//       {matchingModalOpen && currentTransaction && (
//         <MatchTransactionModal
//           transaction={currentTransaction}
//           paymentOptions={paymentOptions}
//           transactionOptions={transactionOptions}
//           onClose={() => setMatchingModalOpen(false)}
//           onMatch={() => {
//             fetchTransactions(selectedStatement.id);
//             setMatchingModalOpen(false);
//           }}
//         />
//       )}
//     </React.Fragment>
//   );
// }

// // Upload Statement Modal Component
// const UploadStatementModal = ({ onClose, onUpload }) => {
//   const [bankAccount, setBankAccount] = useState("");
//   const [statementDate, setStatementDate] = useState("");
//   const [openingBalance, setOpeningBalance] = useState("");
//   const [closingBalance, setClosingBalance] = useState("");
//   const [file, setFile] = useState(null);
//   const [isUploading, setIsUploading] = useState(false);
//   const environment =
//     window.location.hostname === "localhost" ? "development" : "production";
//   const apiUrl = config[environment].apiUrl;

//   const handleSubmit = (e) => {
//     e.preventDefault();
//     if (!file) return alert("Please select a file");

//     const formData = new FormData();
//     formData.append("bank_account", bankAccount);
//     formData.append("statement_date", statementDate);
//     formData.append("opening_balance", openingBalance);
//     formData.append("closing_balance", closingBalance);
//     formData.append("statement", file);

//     setIsUploading(true);

//     fetch(`/reconciliation/upload`, {
//       method: "POST",
//       body: formData,
//     })
//       .then((res) => res.json())
//       .then((data) => {
//         alert(
//           `Statement uploaded with ${data.transactionCount || 0} transactions`,
//         );
//         onUpload();
//         onClose();
//       })
//       .catch((error) => {
//         alert("Upload failed: " + error.message);
//       })
//       .finally(() => {
//         setIsUploading(false);
//       });
//   };

//   return (
//     <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
//       <div className="bg-white rounded-lg shadow-xl w-full max-w-2xl">
//         <div className="p-6">
//           <h2 className="text-xl font-bold mb-4">Upload Bank Statement</h2>

//           <form onSubmit={handleSubmit}>
//             <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6">
//               <div>
//                 <label className="block text-sm font-medium mb-1">
//                   Bank Account
//                 </label>
//                 <input
//                   type="text"
//                   value={bankAccount}
//                   onChange={(e) => setBankAccount(e.target.value)}
//                   className="w-full border border-gray-300 rounded-md p-2"
//                   required
//                 />
//               </div>

//               <div>
//                 <label className="block text-sm font-medium mb-1">
//                   Statement Date
//                 </label>
//                 <input
//                   type="date"
//                   value={statementDate}
//                   onChange={(e) => setStatementDate(e.target.value)}
//                   className="w-full border border-gray-300 rounded-md p-2"
//                   required
//                 />
//               </div>

//               <div>
//                 <label className="block text-sm font-medium mb-1">
//                   Opening Balance
//                 </label>
//                 <input
//                   type="number"
//                   step="0.01"
//                   value={openingBalance}
//                   onChange={(e) => setOpeningBalance(e.target.value)}
//                   className="w-full border border-gray-300 rounded-md p-2"
//                   required
//                 />
//               </div>

//               <div>
//                 <label className="block text-sm font-medium mb-1">
//                   Closing Balance
//                 </label>
//                 <input
//                   type="number"
//                   step="0.01"
//                   value={closingBalance}
//                   onChange={(e) => setClosingBalance(e.target.value)}
//                   className="w-full border border-gray-300 rounded-md p-2"
//                   required
//                 />
//               </div>

//               <div className="md:col-span-2">
//                 <label className="block text-sm font-medium mb-1">
//                   Statement File (CSV)
//                 </label>
//                 <input
//                   type="file"
//                   accept=".csv"
//                   onChange={(e) => setFile(e.target.files[0])}
//                   className="w-full border border-gray-300 rounded-md p-2"
//                   required
//                 />
//                 <p className="text-xs text-gray-500 mt-1">
//                   Supported format: Date, Description, Reference, Amount,
//                   Balance
//                 </p>
//               </div>
//             </div>

//             <div className="flex justify-end space-x-3">
//               <button
//                 type="button"
//                 onClick={onClose}
//                 className="px-4 py-2 border border-gray-300 rounded-md"
//                 disabled={isUploading}
//               >
//                 Cancel
//               </button>
//               <button
//                 type="submit"
//                 className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 flex items-center"
//                 disabled={isUploading}
//               >
//                 {isUploading ? (
//                   <>
//                     <svg
//                       className="animate-spin -ml-1 mr-2 h-4 w-4 text-white"
//                       xmlns="http://www.w3.org/2000/svg"
//                       fill="none"
//                       viewBox="0 0 24 24"
//                     >
//                       <circle
//                         className="opacity-25"
//                         cx="12"
//                         cy="12"
//                         r="10"
//                         stroke="currentColor"
//                         strokeWidth="4"
//                       ></circle>
//                       <path
//                         className="opacity-75"
//                         fill="currentColor"
//                         d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
//                       ></path>
//                     </svg>
//                     Uploading...
//                   </>
//                 ) : (
//                   <>
//                     <HiUpload className="mr-2" />
//                     Upload Statement
//                   </>
//                 )}
//               </button>
//             </div>
//           </form>
//         </div>
//       </div>
//     </div>
//   );
// };

// // Match Transaction Modal Component
// const MatchTransactionModal = ({
//   transaction,
//   paymentOptions,
//   transactionOptions,
//   onClose,
//   onMatch,
// }) => {
//   const [selectedPayment, setSelectedPayment] = useState("");
//   const [selectedTransaction, setSelectedTransaction] = useState("");

//   const handleMatch = () => {
//     if (!selectedPayment && !selectedTransaction) {
//       return alert("Please select a payment or transaction");
//     }

//     fetch("/api/reconciliation/match-manual", {
//       method: "POST",
//       headers: { "Content-Type": "application/json" },
//       body: JSON.stringify({
//         statementTransactionId: transaction.id,
//         paymentId: selectedPayment,
//         transactionId: selectedTransaction,
//       }),
//     }).then(() => {
//       onMatch();
//       onClose();
//     });
//   };

//   return (
//     <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
//       <div className="bg-white rounded-lg shadow-xl w-full max-w-4xl">
//         <div className="p-6">
//           <h2 className="text-xl font-bold mb-4">Match Transaction</h2>

//           <div className="mb-6 bg-gray-50 p-4 rounded-lg">
//             <div className="grid grid-cols-4 gap-4">
//               <div>
//                 <div className="text-sm text-gray-500">Date</div>
//                 <div>
//                   {new Date(transaction.transaction_date).toLocaleDateString()}
//                 </div>
//               </div>
//               <div>
//                 <div className="text-sm text-gray-500">Amount</div>
//                 <div className="font-medium">
//                   {transaction.amount.toLocaleString()}
//                 </div>
//               </div>
//               <div>
//                 <div className="text-sm text-gray-500">Description</div>
//                 <div>{transaction.description}</div>
//               </div>
//               <div>
//                 <div className="text-sm text-gray-500">Reference</div>
//                 <div>{transaction.reference}</div>
//               </div>
//             </div>
//           </div>

//           <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
//             {/* Payment Options */}
//             <div>
//               <h3 className="font-medium mb-3">Match with Payment</h3>
//               <div className="max-h-60 overflow-y-auto border rounded">
//                 {paymentOptions.length === 0 ? (
//                   <div className="p-4 text-center text-gray-500">
//                     No matching payments found
//                   </div>
//                 ) : (
//                   paymentOptions.map((payment) => (
//                     <div
//                       key={payment.id}
//                       className={`p-3 border-b cursor-pointer hover:bg-gray-50 ${
//                         selectedPayment === payment.id ? "bg-blue-50" : ""
//                       }`}
//                       onClick={() => {
//                         setSelectedPayment(payment.id);
//                         setSelectedTransaction("");
//                       }}
//                     >
//                       <div className="font-medium">Payment #{payment.id}</div>
//                       <div className="text-sm">
//                         {new Date(payment.paymentDate).toLocaleDateString()} •
//                         Ksh {payment.amount.toLocaleString()}
//                       </div>
//                       <div className="text-xs text-gray-500 truncate">
//                         {payment.note}
//                       </div>
//                     </div>
//                   ))
//                 )}
//               </div>
//             </div>

//             {/* Transaction Options */}
//             <div>
//               <h3 className="font-medium mb-3">Match with Transaction</h3>
//               <div className="max-h-60 overflow-y-auto border rounded">
//                 {transactionOptions.length === 0 ? (
//                   <div className="p-4 text-center text-gray-500">
//                     No matching transactions found
//                   </div>
//                 ) : (
//                   transactionOptions.map((txn) => (
//                     <div
//                       key={txn.id}
//                       className={`p-3 border-b cursor-pointer hover:bg-gray-50 ${
//                         selectedTransaction === txn.id ? "bg-blue-50" : ""
//                       }`}
//                       onClick={() => {
//                         setSelectedTransaction(txn.id);
//                         setSelectedPayment("");
//                       }}
//                     >
//                       <div className="font-medium">Transaction #{txn.id}</div>
//                       <div className="text-sm">
//                         {new Date(txn.transaction_date).toLocaleDateString()} •
//                         Ksh {txn.amount.toLocaleString()}
//                       </div>
//                       <div className="text-xs text-gray-500 truncate">
//                         {txn.description}
//                       </div>
//                     </div>
//                   ))
//                 )}
//               </div>
//             </div>
//           </div>

//           <div className="mt-6 flex justify-end space-x-3">
//             <button
//               onClick={onClose}
//               className="px-4 py-2 border border-gray-300 rounded-md"
//             >
//               Cancel
//             </button>
//             <button
//               onClick={handleMatch}
//               className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700"
//             >
//               Confirm Match
//             </button>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// src/pages/accountant/BankReconciliation.jsx
import React, { useState, useEffect } from "react";
import {
  Modal,
  Button,
  Form,
  Row,
  Col,
  Table,
  Badge,
  Container,
} from "react-bootstrap";
import { HiUpload, HiDocumentDownload, HiRefresh } from "react-icons/hi";
import Select from "react-select";
import DataTable from "react-data-table-component";
import axios from "axios";
import config from "../../config";
import { bankData } from "../../utils/banks";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";

export default function BankReconciliation() {
  const [statements, setStatements] = useState([]);
  const [selectedStatement, setSelectedStatement] = useState(null);
  const [transactions, setTransactions] = useState([]);
  const [showUploadModal, setShowUploadModal] = useState(false);
  const [showMatchModal, setShowMatchModal] = useState(false);
  const [currentTransaction, setCurrentTransaction] = useState(null);
  const [paymentOptions, setPaymentOptions] = useState([]);
  const [transactionOptions, setTransactionOptions] = useState([]);
  const [bankAccounts, setBankAccounts] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const account = useSelector((state) => state.account.user);
  const userId = account.id;
  const userName = account.firstname;

  const environment =
    window.location.hostname === "localhost" ? "development" : "production";
  const apiUrl = config[environment].apiUrl;

  useEffect(() => {
    fetchStatements();
    fetchBankAccounts();
  }, []);

  const fetchBankAccounts = async () => {
    try {
      const response = await api.get(`/payments/bank-accounts`);
      setBankAccounts(response.data);
    } catch (error) {
      console.error("Error fetching bank accounts:", error);
    }
  };

  const fetchStatements = async () => {
    setIsLoading(true);
    try {
      const response = await api.get(`/reconciliation/statements`);
      setStatements(response.data);
    } catch (error) {
      console.error("Error fetching statements:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const fetchTransactions = async (statementId) => {
    setIsLoading(true);
    try {
      const response = await api.get(
        `/reconciliation/transactions/${statementId}`,
      );
      setTransactions(response.data);
    } catch (error) {
      console.error("Error fetching transactions:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleStatementSelect = (statement) => {
    setSelectedStatement(statement);
    fetchTransactions(statement.id);
  };

  const handleAutoMatch = async () => {
    try {
      await api.post(
        `/reconciliation/match/${selectedStatement.id}`,
      );
      fetchTransactions(selectedStatement.id);
      alert("Auto-matching completed!");
    } catch (error) {
      console.error("Auto-match error:", error);
      alert("Error during auto-matching");
    }
  };

  const handleManualMatch = async (transaction) => {
    setCurrentTransaction(transaction);

    try {
      const paymentsResponse = await api.get(`/get-payments`, {
        params: {
          amount: transaction.amount,
          date: transaction.transaction_date,
        },
      });
      setPaymentOptions(paymentsResponse.data);

      const transactionsResponse = await api.get(
        `/reconciliation/transactions`,
        {
          params: {
            amount: transaction.amount,
            date: transaction.transaction_date,
          },
        },
      );
      setTransactionOptions(transactionsResponse.data);

      setShowMatchModal(true);
    } catch (error) {
      console.error("Error fetching matching options:", error);
    }
  };

  const handleReconcile = async () => {
    try {
      const response = await api.post(
        `/reconciliation/reconcile/${selectedStatement.id}`,
      );
      alert(
        `Reconciliation completed! Discrepancy: Ksh ${response.data.discrepancy.toLocaleString()}`,
      );
      fetchStatements();
    } catch (error) {
      console.error("Reconciliation error:", error);
      alert("Error during reconciliation");
    }
  };

  const transactionColumns = [
    {
      name: "Date",
      selector: (row) => new Date(row.transaction_date).toLocaleDateString(),
      sortable: true,
    },
    {
      name: "Description",
      selector: (row) => row.description,
      sortable: true,
    },
    {
      name: "Reference",
      selector: (row) => row.reference,
      sortable: true,
    },
    {
      name: "Amount",
      selector: (row) => row.amount,
      format: (row) => (
        <span className={row.amount > 0 ? "text-success" : "text-danger"}>
          {row.amount > 0 ? "+" : ""}
          {row.amount.toLocaleString()}
        </span>
      ),
      sortable: true,
    },
    {
      name: "Status",
      cell: (row) => (
        <Badge
          bg={
            row.status === "reconciled"
              ? "success"
              : row.status === "matched"
              ? "primary"
              : "warning"
          }
          className="text-capitalize"
        >
          {row.status}
        </Badge>
      ),
      sortable: true,
    },
    {
      name: "Actions",
      cell: (row) =>
        row.status !== "reconciled" && (
          <Button
            variant="outline-primary"
            size="sm"
            onClick={() => handleManualMatch(row)}
          >
            Match
          </Button>
        ),
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
    },
  ];

  return (
    <React.Fragment>
      <div className="d-flex justify-content-between align-items-center mb-4">
        {/* <h1 className="h2">Bank Reconciliation</h1> */}
        <Button variant="primary" onClick={() => setShowUploadModal(true)}>
          <HiUpload className="me-1" /> Upload Statement
        </Button>
      </div>

      <Row>
        <Col md={4} className="mb-4">
          <div className="bg-white rounded shadow-sm h-100">
            <div className="p-3 border-bottom">
              <h5 className="mb-0">Bank Statements</h5>
            </div>
            <div className="overflow-auto" style={{ maxHeight: "70vh" }}>
              {statements.length === 0 ? (
                <div className="p-4 text-center text-muted">
                  No statements found
                </div>
              ) : (
                statements.map((statement) => (
                  <div
                    key={statement.id}
                    className={`p-3 border-bottom cursor-pointer ${
                      selectedStatement?.id === statement.id ? "bg-light" : ""
                    }`}
                    onClick={() => handleStatementSelect(statement)}
                  >
                    <div className="fw-bold">{statement.bank_account}</div>
                    <div className="small text-muted">
                      {new Date(statement.statement_date).toLocaleDateString()}
                    </div>
                    <div className="d-flex justify-content-between mt-2">
                      <span className="small">
                        {statement.reconciled_count}/
                        {statement.transaction_count} reconciled
                      </span>
                      <Badge
                        bg={statement.processed ? "success" : "warning"}
                        className="text-capitalize"
                      >
                        {statement.processed ? "Reconciled" : "Pending"}
                      </Badge>
                    </div>
                  </div>
                ))
              )}
            </div>
          </div>
        </Col>

        <Col md={8}>
          {selectedStatement && (
            <div className="bg-white rounded shadow-sm h-100">
              <div className="p-3 border-bottom d-flex justify-content-between align-items-center">
                <div>
                  <h5 className="mb-0">
                    {selectedStatement.bank_account} -{" "}
                    {new Date(
                      selectedStatement.statement_date,
                    ).toLocaleDateString()}
                  </h5>
                  <div className="small text-muted">
                    Opening: Ksh{" "}
                    {selectedStatement.opening_balance.toLocaleString()} •
                    Closing: Ksh{" "}
                    {selectedStatement.closing_balance.toLocaleString()}
                  </div>
                </div>
                <div>
                  <Button
                    variant="success"
                    className="me-2"
                    onClick={handleAutoMatch}
                  >
                    <HiRefresh className="me-1" /> Auto Match
                  </Button>
                  <Button
                    variant="primary"
                    onClick={handleReconcile}
                    disabled={selectedStatement.processed}
                  >
                    Reconcile Statement
                  </Button>
                </div>
              </div>
              <div>
                <DataTable
                  columns={transactionColumns}
                  data={transactions}
                  progressPending={isLoading}
                  pagination
                  highlightOnHover
                  noDataComponent={
                    <div className="py-4 text-center text-muted">
                      No transactions found for this statement
                    </div>
                  }
                />
              </div>
            </div>
          )}
        </Col>
      </Row>

      {/* Upload Statement Modal */}
      <UploadStatementModal
        show={showUploadModal}
        onHide={() => setShowUploadModal(false)}
        onUpload={fetchStatements}
        bankAccounts={bankAccounts}
        apiUrl={apiUrl}
        userName={userName}
        userId={userId}
      />

      {/* Match Transaction Modal */}
      {currentTransaction && (
        <MatchTransactionModal
          show={showMatchModal}
          onHide={() => setShowMatchModal(false)}
          transaction={currentTransaction}
          paymentOptions={paymentOptions}
          transactionOptions={transactionOptions}
          onMatch={() => {
            fetchTransactions(selectedStatement.id);
            setShowMatchModal(false);
          }}
          apiUrl={apiUrl}
        />
      )}
    </React.Fragment>
  );
}

// Upload Statement Modal Component
const UploadStatementModal = ({
  show,
  onHide,
  onUpload,
  bankAccounts,
  apiUrl,
  userName,
  userId,
}) => {
  const [formData, setFormData] = useState({
    bank_account: "",
    statement_date: new Date().toISOString().split("T")[0],
    opening_balance: "",
    closing_balance: "",
    uploaded_by: userId,
    password: "",
  });
  const [file, setFile] = useState(null);
  const [isUploading, setIsUploading] = useState(false);
  const [bankAccountOptions, setBankAccountOptions] = useState([]);

  useEffect(() => {
    if (bankAccounts.length) {
      const options = bankAccounts.map((b) => ({
        value: b.id,
        label: `${b.name} (${b.code})`,
      }));
      setBankAccountOptions(options);
    }
  }, [bankAccounts]);

  const handleChange = (name, value) => {
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleFileChange = (e) => {
    setFile(e.target.files[0]);
};

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!file) return alert("Please select a file");

    const formPayload = new FormData();
    formPayload.append("bank_account", formData.bank_account.value);
    formPayload.append("statement_date", formData.statement_date);
    formPayload.append("opening_balance", formData.opening_balance);
    formPayload.append("closing_balance", formData.closing_balance);
    formPayload.append("uploaded_by", userId);
    formPayload.append("password", formData.password);
    formPayload.append("statement", file);

    setIsUploading(true);

    try {
      const response = await api.post(
        `/reconciliation/uploads`,
        formPayload,
        {
          headers: { "Content-Type": "multipart/form-data" },
        },
      );

      toast.success(
        `Statement uploaded with ${response.data.transactionCount} transactions`,
      );
      onUpload();
      onHide();
    } catch (error) {
      toast.error(
        "Upload failed: " + (error.response?.data?.message || error.message),
      );
    } finally {
      setIsUploading(false);
    }
  };

  return (
    <Modal show={show} onHide={onHide} size="lg">
      <Modal.Header closeButton>
        <Modal.Title>Upload Bank Statement</Modal.Title>
      </Modal.Header>
      <Form onSubmit={handleSubmit}>
        <Modal.Body>
          <Row className="g-3">
            <Col md={6}>
              <Form.Group>
                <Form.Label>Bank Account</Form.Label>
                <Select
                  options={bankAccountOptions}
                  value={bankAccountOptions.find(
                    (opt) => opt.value === formData.bank_account,
                  )}
                  onChange={(selected) =>
                    handleChange("bank_account", selected)
                  }
                  isSearchable
                  required
                />
              </Form.Group>
            </Col>
            <Col md={6}>
              <Form.Group>
                <Form.Label>Statement Date</Form.Label>
                <Form.Control
                  type="date"
                  value={formData.statement_date}
                  onChange={(e) =>
                    handleChange("statement_date", e.target.value)
                  }
                  required
                />
              </Form.Group>
            </Col>
            <Col md={6}>
              <Form.Group>
                <Form.Label>Opening Balance</Form.Label>
                <Form.Control
                  type="number"
                  step="0.01"
                  value={formData.opening_balance}
                  onChange={(e) =>
                    handleChange("opening_balance", e.target.value)
                  }
                  required
                />
              </Form.Group>
            </Col>
            <Col md={6}>
              <Form.Group>
                <Form.Label>Closing Balance</Form.Label>
                <Form.Control
                  type="number"
                  step="0.01"
                  value={formData.closing_balance}
                  onChange={(e) =>
                    handleChange("closing_balance", e.target.value)
                  }
                  required
                />
              </Form.Group>
            </Col>

            <Col md={6}>
              <Form.Group>
                <Form.Label>Statement File</Form.Label>
                <Form.Control
                  type="file"
                  accept=".pdf,.csv,.xlsx"
                  onChange={handleFileChange}
                  required
                />
                <Form.Text className="text-muted">
                  Supported formats: PDF, CSV, Excel
                </Form.Text>
              </Form.Group>
            </Col>
            {/* <Col md={6}>
              <Form.Group>
                <Form.Label>Password (For encrypted pdf)</Form.Label>
                <Form.Control
                  type="password"
                  value={formData.password}
                  onChange={(e) => handleChange("password", e.target.value)}
                />
              </Form.Group>
            </Col> */}
          </Row>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={onHide} disabled={isUploading}>
            Cancel
          </Button>
          <Button variant="primary" type="submit" disabled={isUploading}>
            {isUploading ? "Uploading..." : "Upload Statement"}
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
};

// Match Transaction Modal Component
const MatchTransactionModal = ({
  show,
  onHide,
  transaction,
  paymentOptions,
  transactionOptions,
  onMatch,
  apiUrl,
}) => {
  const [selectedPayment, setSelectedPayment] = useState(null);
  const [selectedTransaction, setSelectedTransaction] = useState(null);
  const [isMatching, setIsMatching] = useState(false);

  const handleMatch = async () => {
    if (!selectedPayment && !selectedTransaction) {
      return alert("Please select a payment or transaction");
    }

    setIsMatching(true);
    try {
      await api.post(`/reconciliation/match-manual`, {
        statementTransactionId: transaction.id,
        paymentId: selectedPayment?.id,
        transactionId: selectedTransaction?.id,
      });
      onMatch();
      onHide();
    } catch (error) {
      console.error("Matching error:", error);
      alert("Error matching transaction");
    } finally {
      setIsMatching(false);
    }
  };

  // Prepare options for dropdowns
  const paymentSelectOptions = paymentOptions.map((p) => ({
    value: p,
    label: `Payment #${p.id} - ${new Date(
      p.paymentDate,
    ).toLocaleDateString()} - Ksh ${p.amount.toLocaleString()}`,
  }));

  const transactionSelectOptions = transactionOptions.map((t) => ({
    value: t,
    label: `Transaction #${t.id} - ${new Date(
      t.transaction_date,
    ).toLocaleDateString()} - Ksh ${t.amount.toLocaleString()}`,
  }));

  return (
    <Modal show={show} onHide={onHide} size="lg">
      <Modal.Header closeButton>
        <Modal.Title>Match Transaction</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="mb-4 p-3 bg-light rounded">
          <Row>
            <Col md={3}>
              <div className="text-muted">Date</div>
              <div>
                {new Date(transaction.transaction_date).toLocaleDateString()}
              </div>
            </Col>
            <Col md={3}>
              <div className="text-muted">Amount</div>
              <div className="fw-bold">
                {transaction.amount.toLocaleString()}
              </div>
            </Col>
            <Col md={3}>
              <div className="text-muted">Description</div>
              <div>{transaction.description}</div>
            </Col>
            <Col md={3}>
              <div className="text-muted">Reference</div>
              <div>{transaction.reference}</div>
            </Col>
          </Row>
        </div>

        <Row className="g-3">
          <Col md={6}>
            <Form.Group>
              <Form.Label>Match with Payment</Form.Label>
              <Select
                options={paymentSelectOptions}
                value={paymentSelectOptions.find(
                  (opt) => opt.value.id === selectedPayment?.id,
                )}
                onChange={(selected) => {
                  setSelectedPayment(selected?.value || null);
                  setSelectedTransaction(null);
                }}
                isClearable
                placeholder="Select payment..."
              />
            </Form.Group>
          </Col>
          <Col md={6}>
            <Form.Group>
              <Form.Label>Match with Transaction</Form.Label>
              <Select
                options={transactionSelectOptions}
                value={transactionSelectOptions.find(
                  (opt) => opt.value.id === selectedTransaction?.id,
                )}
                onChange={(selected) => {
                  setSelectedTransaction(selected?.value || null);
                  setSelectedPayment(null);
                }}
                isClearable
                placeholder="Select transaction..."
              />
            </Form.Group>
          </Col>
        </Row>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide} disabled={isMatching}>
          Cancel
        </Button>
        <Button variant="primary" onClick={handleMatch} disabled={isMatching}>
          {isMatching ? "Matching..." : "Confirm Match"}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};
